export enum ExploreGroupNames {
    POPULAR_GROUPS = "Popular groups",
    ALL_GROUPS = "All groups",
    MY_RECOMMENDED_GROUPS = "My recommended groups",
}
